<template>
  <div class="h-dialogContainer">
    <form id='delRange'>
      <div class='row h-row-inputBox'>
        <div class="col-sm-6 h-col-inputBox">
          <div class='h-inputLit'>{{title}}:</div>
        </div>  
      </div>
      <div class='row h-row-inputBox'>
        <div class="col-sm-5 h-col-inputBox">
          <ejs-textbox name='startSupi' :placeholder='$t("Supi.character15")' v-model="param.startSupi"></ejs-textbox>
        </div>
        <span class="col-sm-1 h-col-inputBox">~</span>
        <div class="col-sm-5 h-col-inputBox"> 
          <ejs-textbox name='endSupi' :placeholder='$t("Supi.character15")' v-model="param.endSupi"></ejs-textbox>
        </div>
      </div>
    </form>
    <Notification ref='notification' :position='position' timeOut='2000' ></Notification>
  </div>
</template>

<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
import ajaxUrl from "../../../data/ajaxUrl";
import Notification from "../../../util/tipDialog/Notification";
import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: "DelRangeUserForm",
  components: { 
    Notification,
  }, 
  methods: {
    getDatas() {
      if (this.validate()) {
        return this.param;
      }
      return;
    },
    bindValidate() {            
      this.formObj = new FormValidator('#delRange', this.validationOption);
    },
    validate() {
      return this.formObj.validate();
    },    
    delRangeUser(ne, callback) { 
      const formData = this.getDatas();
      if (formData) {
        const count = Number(this.param.endSupi) - Number(this.param.startSupi) + 1;
        if (count <= 0) { 
          this.$loading.hideLoadding();
          EventBus.$emit('toast', {type: 'error', content: '至少包含1条'});
          return;
        }
        if (count > 10000) { 
          this.$loading.hideLoadding();
          EventBus.$emit('toast', {type: 'error', content: '最多包含10000条'});
          return;
        }
        const delUserList = [];
        // for (let i=0; i<count; i++) {
        //   delUserList.push({
        //     startSupi: (Number(formData.startSupi) + i).toString(),
        //   })
        // }

      let startSupiSize = formData.startSupi.length; //加的数若位数小于起始数则补齐0
      for (let i = 0; i < count; i++) {
        let datai = (Number(formData.startSupi) + i).toString();
        let dataiSize = datai.length;
        if (dataiSize < startSupiSize) {
          for (let z = 0; z < startSupiSize - dataiSize; z++) {
            datai = "0" + datai; //不够的就在前面补0
          }
        }
        delUserList.push({
          startSupi: datai
        });
      }
        const params = { 
          vo: {
            startSupi: formData.startSupi,
            count: count,
            bitmask: 0,
            supiList:["0"],
          }, 
          info: {
            msgid: "28694",
            neid: ne.neid,
          } 
        }; 
        this.$axios.post(ajaxUrl.requestCommonD, params).then(response => {
          // const delUserList = [];
          // for (let i=0; i<count; i++) {
          //   delUserList.push({
          //     supi: (Number(formData.startSupi) + i).toString(),
          //   })
          // }
          // if (callback) {
          //   callback(response, delUserList);
          // }
          if (callback) {
            callback(response, delUserList);
          }
        }); 
      }         
    }
  },
  data() {
    return {
      ne: null,
      opCode: "add",
      msgId: "25429",
      timer1: null,
      title: this.$t("Supi.supiRange"),
      position: { X: 'Center', Y: 'Top' },
      formObj: null,
      validationOption: {
        customPlacement(inputElement, errorElement) {
            errorElement.style.float = 'left';
            inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {                    
          startSupi: {                        
              required: [true, '此处不可空白'],
              regex: ['^\\d*$', '无效的整数'],
              minLength: [5, '最少长度5'],
              maxLength: [15, '最大长度15'],              
          },
          endSupi: {
              required: [true, '此处不可空白'],
              regex: ['^\\d*$', '无效的整数'],
              minLength: [5, '最少长度5'],
              maxLength: [15, '最大长度15'],              
          },
        }
      }, 
      param: {
        startSupi: '',
        endSupi: ''
      },
    };
  },
  mounted() {
    this.timer1 = setTimeout(() => {
      this.bindValidate();
    }, 200);
  },
  beforeDestroy() {
    if (this.timer1) {
      clearTimeout(this.timer1);
      this.timer1 = null;
    }
  }
};
</script>
